module.exports = __webpack_public_path__ + "img/happynewyear.e79e3967.png";